import React, { useState, useCallback } from 'react';

export const SupportModalContext = React.createContext({
    topic: null,
    showSupportModal: () => { },
    hideSupportModal: () => { }
});

export default function SupportModalProvider({ children }) {
    const [topic, setTopic] = useState(null);
    const showSupportModal = (topic, onClose) => setTopic({ topic, onClose });
    const hideSupportModal = () => setTopic(null);

    const contextValue = {
        topic,
        showSupportModal: useCallback((topic, onClose) => showSupportModal(topic, onClose), []),
        hideSupportModal: useCallback(() => hideSupportModal(), [])
    };

    return (
        <SupportModalContext.Provider value={contextValue}>
            {children}
        </SupportModalContext.Provider>
    );
}
